export { FastshiftDashboardV2 } from "./src/fastshift-dashboard-v2";
